// Canonical edit/draft/save/cancel panel state (see CLAUDE.md "useEditablePanel").
// The draft is seeded from `source` exactly when editing begins and is kept
// untouched across failed saves; reset() discards it and closes the panel.
import { useCallback, useRef, useState } from "react";

export function useEditablePanel(source) {
  const sourceRef = useRef(source);
  sourceRef.current = source;
  const [editing, setEditingState] = useState(false);
  const [draft, setDraft] = useState(() => ({ ...(source || {}) }));
  const setEditing = useCallback((next) => {
    if (next) setDraft({ ...(typeof sourceRef.current === "function" ? sourceRef.current() : sourceRef.current || {}) });
    setEditingState(Boolean(next));
  }, []);
  const setField = useCallback((key, value) => setDraft((d) => ({ ...d, [key]: value })), []);
  const reset = useCallback(() => {
    setDraft({ ...(typeof sourceRef.current === "function" ? sourceRef.current() : sourceRef.current || {}) });
    setEditingState(false);
  }, []);
  return { draft, setField, editing, setEditing, reset };
}
